export class XHR {

    constructor() {}

    get(url) {
        return this._makeRequest('GET', url);
    }

    post(url, params) {
        return this._makeRequest("POST", url, params);
    }

    _makeRequest(method, url, params) {
        let m = method;
        let u = url;
        let p = '';
        return new Promise((resolve, reject) => {
            const xhr = new XMLHttpRequest();

            xhr.open(m, u);

            xhr.onload = () => {
                resolve(xhr.response);
            };

            xhr.onerror = () => {
                reject(xhr.statusText);
            };

            if(params && typeof params === 'object') {
                p = JSON.stringify(params);
            }

            xhr.send(p);
        });
    }
}



// WEBPACK FOOTER //
// ./src/modules/Shared/XHR/index.js